import React from 'react';

import i18n from '@client/utils/i18n';
import { LightRecipeDoc, SpectrogramPoint } from '@ledium/types';
import { ItemList } from '@ledium/ui-common';

type LightRecipeItem = LightRecipeDoc & { id: string };

const LightRecipesMainMenu = () => {
    function isLocked(lightRecipe: LightRecipeItem) {
        if (lightRecipe.locked?.reason) {
            if (lightRecipe.locked.reason === 'RUNNING_PROJECT') {
                return i18n('light_recipe_running_project') as string;
            }
        }
        return false as const;
    }

    function isLinked(lightRecipe: LightRecipeItem) {
        if (lightRecipe.linked?.reason === 'LINKED_PROJECT') {
            return i18n('light_recipe_linked_project') as string;
        }
        return false as const;
    }

    function chart(item: LightRecipeItem): SpectrogramPoint[] {
        return item.spectrogram;
    }

    return <ItemList<LightRecipeItem> chart={chart} isLocked={isLocked} isLinked={isLinked} />;
};

export default LightRecipesMainMenu;
